/**
 * Created by weid on 2017/6/21.
 */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createReducer } from '../reducers/createReducer';
import { createQmyxReducer } from '../reducers/createQmyxReducer';

export default (type = 'agency') => {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
        : compose;

    const enhancer = composeEnhancers(applyMiddleware(thunk));

    const store = createStore(type === 'agency' ? createReducer() : createQmyxReducer(), enhancer);

    store.asyncReducers = {};

    return store;
};



// WEBPACK FOOTER //
// ./src/rootRedux/store/createStore.js